
import './TextArea.css';

const TextArea = (props) => {

    

    const handleChange = (inputText) => {
        
        let value = ''

        switch (props.type){
            case 'hex':
                value = inputText.includes(props.placeHolder) || inputText === '' ? inputText.replace(props.placeHolder,'') : inputText;
                // remove #
                value = value.replaceAll('#', '');
                // remove last
                value = value.substring(0, 6);
                // callback
                props.callback(value, props.type);
                break;
            case 'r':
            case 'g':
            case 'b':
                // remove last
                value = inputText.substring(0, 3);
                // callback
                props.callback(props.type, value);
                break;
            default:
        }

        
    } 

    // compute alerts
    let valueText = typeof props.value !== 'undefined' ? props.value : '';
    let alert = false;
    switch (props.type){
        case 'hex':
            valueText = '#' + valueText;
            if(props.value === '' || typeof props.value === 'undefined' || props.value.length < 6){
                alert = true;
            }else if(parseInt(props.value,16).toString(16) !== props.value){
                alert = true;
            }
            break;
        case 'r':
        case 'g':
        case 'b':
            if(props.value > 255 || props.value < 0){
                alert = true;
            }
            if(isNaN(parseInt(props.value))){
                alert = true;
            }
            break;
        default:
    };

    return <div className={`text-area ${typeof props.className !== 'undefined' ? props.className : ''} ${alert ? 'alert' : ''}`} >
        <textarea 
            value= {props.value !== '' || typeof props.value !== 'undefined' ? valueText : props.placeHolder} 
            onChange={(e) => handleChange(e.target.value)} 
            // onPaste={(e) => handlePaste(e)} 
            // onKeyDown={(e) => this.handleKeyDown(e)}
            style={props.textAreaStyle}
        />
    </div>
}

export default TextArea;